

import { Button, Input, Select } from "@alifd/next";
import { MutableRefObject, useContext, useEffect, useRef, useState } from "react";
import Overlay from "@alifd/next/lib/overlay";
import { SelectCollection, toWhere } from "./data";
import { MixIcon } from "../MixIcon";
export class SelectButtonProps {
    onOk: any | undefined;
    onReset: any | undefined;
    data: any;
    needState?: boolean;
}

export function SelectButton(props: SelectButtonProps) {
    const _SelectCollection = SelectCollection;
    const [visible, setVisible] = useState<boolean>(false);
    const [data, setData] = useState<any>({
        UserId: { type: 0, value: '', value1: '' },
        UserName: { type: 0, value: '', value1: '' },
        Gender: { type: 0, value: '', value1: '' },
        State: { type: 0, value: '', value1: '' },
        TelNumber: { type: 0, value: '', value1: '' },
    });
    const genderCelletion = [{ value: '0', key: "女" }, { value: '1', key: "男" }];
    const stateCelletion = [{ value: 'AC', key: "激活" }, { value: 'LC', key: "锁定" }];
    const [needState, setNeedState] = useState<any>(true);
    const onVisibleChange = (evt: any) => {
        setVisible(evt)
    }
    const handleOK = () => {
        let res;
        if (data) {
            let _datas = [] as any;
            for (let i in data) {
                let fValue = data[i].value;
                if (i === 'Gender' && fValue !== '' && fValue != null) {
                    fValue = Number(fValue);
                }
                _datas.push({ id: i, controlCharField: data[i].type, fValueField: fValue, lValueField: data[i].value1 });
            }
            res = toWhere(_datas);
        }
        setVisible(false)
        if (props.onOk) {
            props.onOk(res);
        }
    }
    const haneleReset = () => {
        setData({
            UserId: { type: 0, value: '', value1: '' },
            UserName: { type: 0, value: '', value1: '' },
            Gender: { type: 0, value: '', value1: '' },
            State: { type: 0, value: '', value1: '' },
            TelNumber: { type: 0, value: '', value1: '' },
        });
    }

    useEffect(() => {
        if (props.data) {
            setData({ ...props.data });
        }
        if (props.needState === false)
            setNeedState(false);

    }, [props.data]);
    return (
        <>

            <Overlay.Popup
                v2
                triggerType="click"
                placement="bl"
                trigger={<Button className="custom-btn " style={{
                    borderColor: 'rgb(232, 232, 232)',
                    borderRadius: '5px',
                    fontSize: '14px',
                    height: '40px',
                    padding: '0 16px',
                    borderWidth: '1px'
                }}
                    type="normal" size="medium"
                    onClick={() => { setVisible(!visible) }}>  <MixIcon value="1:funnelOutline" size="xs"></MixIcon>筛选</Button>}
                visible={visible}
                onVisibleChange={onVisibleChange}
            >
                <div className="custom-selectbutton" style={{ width: '450px', background: '#ffffff', borderColor: '#e8e8e8', borderRadius: '5px', borderWidth: '1px', borderStyle: 'solid', boxShadow: 'rgba(30, 32, 37, 0.12) 0px 5px 10px', padding: '16px', lineHeight: '21px', height: '600px', display: 'flex', flexDirection: 'column' }}>
                    <div style={{ color: '#262a2a', fontSize: '18px !important', fontWeight: 500, marginBottom: '24px', display: 'flex', gap: '8px' }}>
                        <MixIcon value="1:funnelOutline" ></MixIcon>
                        <label style={{ fontSize: '18px', marginBottom: 0 }}>筛选</label>
                        <p></p>
                    </div>
                    <div style={{ gap: '16px', display: 'flex', flexDirection: 'column', height: 'calc(100% - 54px)' }}>
                        <div style={{ gap: '16px', display: 'flex', flexDirection: 'column', flex: 1 }}>

                            <div style={{ display: 'flex', gap: '8px' }}>
                                <label style={{ width: '84px', lineHeight: '42px' }}>用户编号
                                </label>
                                <div className="custom-form-control" style={{ width: '100px' }}>
                                    <Select popupProps={{ v2: true }} style={{ width: '100%' }} value={data.UserId.type} onChange={(val) => {
                                        setData({ ...data, UserId: { ...data.UserId, type: val } });
                                    }}>
                                        {
                                            _SelectCollection.map((item: any) => {
                                                return <Select.Option value={item.value}>{item.key}</Select.Option>
                                            })
                                        }
                                    </Select></div>
                                <div className="custom-form-control" style={{ flex: 1 }}>
                                    <Input onChange={(val) => {
                                        setData({ ...data, UserId: { ...data.UserId, value: val } });
                                    }} value={data?.UserId.value} style={{ width: '100%' }} />
                                </div>

                            </div>
                            <div style={{ display: 'flex', gap: '8px' }}>
                                <label style={{ width: '84px', lineHeight: '42px' }}>用户名
                                </label>
                                <div className="custom-form-control" style={{ width: '100px' }}>
                                    <Select popupProps={{ v2: true }} style={{ width: '100%' }} value={data?.UserName.type} onChange={(val) => {
                                        setData({ ...data, UserName: { ...data.UserName, type: val } });
                                    }}>
                                        {
                                            _SelectCollection.map((item: any) => {
                                                return <Select.Option value={item.value}>{item.key}</Select.Option>
                                            })
                                        }
                                    </Select></div>
                                <div className="custom-form-control" style={{ flex: 1 }}>
                                    <Input onChange={(val) => {
                                        setData({ ...data, UserName: { ...data.UserName, value: val } });
                                    }} value={data?.UserName.value} style={{ width: '100%' }} />
                                </div>

                            </div>
                            <div style={{ display: 'flex', gap: '8px' }}>
                                <label style={{ width: '84px', lineHeight: '42px' }}>用户性别
                                </label>
                                <div className="custom-form-control" style={{ width: '100px' }}>
                                    <Select popupProps={{ v2: true }} style={{ width: '100%' }} value={data?.Gender.type} onChange={(val) => {
                                        setData({ ...data, Gender: { ...data.Gender, type: val } });
                                    }}>
                                        {
                                            _SelectCollection.map((item: any) => {
                                                return <Select.Option value={item.value}>{item.key}</Select.Option>
                                            })
                                        }
                                    </Select></div>
                                <div className="custom-form-control" style={{ flex: 1 }}>
                                    <Select popupProps={{ v2: true }} style={{ width: '100%' }} hasClear value={data?.Gender.value} onChange={(val) => {
                                        setData({ ...data, Gender: { ...data.Gender, value: val } });
                                    }}>
                                        {
                                            genderCelletion.map((item: any) => {
                                                return <Select.Option value={item.value}>{item.key}</Select.Option>
                                            })
                                        }
                                    </Select>
                                    {/* <Input onChange={(val) => {
                           
                                    }} defaultValue={data?.Gender.value} /> */}
                                </div>

                            </div>
                            {needState && <div style={{ display: 'flex', gap: '8px' }}>
                                <label style={{ width: '84px', lineHeight: '42px' }}>用户状态
                                </label>
                                <div className="custom-form-control" style={{ width: '100px' }}>
                                    <Select popupProps={{ v2: true }} style={{ width: '100%' }} hasClear value={data?.State.type} onChange={(val) => {
                                        setData({ ...data, State: { ...data.State, type: val } });
                                    }}>
                                        {
                                            _SelectCollection.map((item: any) => {
                                                return <Select.Option value={item.value}>{item.key}</Select.Option>
                                            })
                                        }
                                    </Select></div>
                                <div className="custom-form-control" style={{ flex: 1 }}>
                                    <Select popupProps={{ v2: true }} style={{ width: '100%' }} hasClear value={data?.State.value} onChange={(val) => {
                                        setData({ ...data, State: { ...data.State, value: val } });
                                    }}>
                                        {
                                            stateCelletion.map((item: any) => {
                                                return <Select.Option value={item.value}>{item.key}</Select.Option>
                                            })
                                        }
                                    </Select>
                                    {/* <Input onChange={(val) => {

                                    }} defaultValue={data?.State.value} /> */}
                                </div>

                            </div>}
                            {/* <div style={{ display: 'flex', gap: '8px' }}>
                                <label style={{ width: '42px' }}>创建日期
                                </label>
                                <div className="custom-form-control" style={{ flex: 1 }}>     <Select style={{ width: '100%' }} defaultValue={data.type} onChange={(val) => {
                                    console.log(val)
                                }}>
                                    {
                                        _SelectCollection.map((item: any) => {
                                            return <Select.Option value={item.value}>{item.key}</Select.Option>
                                        })
                                    }
                                </Select></div>
                                <div className="custom-form-control" style={{ flex: 1 }}>
                                    <Input onChange={(val) => {
                                        console.log(val)
                                    }} defaultValue={data.value} />
                                </div>

                            </div> */}
                            <div style={{ display: 'flex', gap: '8px' }}>
                                <label style={{ width: '84px', lineHeight: '42px' }}>用户联系电话
                                </label>
                                <div className="custom-form-control" style={{ width: '100px' }}>
                                    <Select popupProps={{ v2: true }} style={{ width: '100%' }} value={data?.TelNumber.type} onChange={(val) => {
                                        setData({ ...data, TelNumber: { ...data.TelNumber, type: val } });
                                    }}>
                                        {
                                            _SelectCollection.map((item: any) => {
                                                return <Select.Option value={item.value}>{item.key}</Select.Option>
                                            })
                                        }
                                    </Select></div>
                                <div className="custom-form-control" style={{ flex: 1 }}>
                                    <Input onChange={(val) => {
                                        setData({ ...data, TelNumber: { ...data.TelNumber, value: val } });
                                    }} value={data?.TelNumber.value} style={{ width: '100%' }} />
                                </div>

                            </div>
                        </div>
                        <div style={{ display: 'flex', gap: '24px' }}>
                            <Button className=" custom-btn reset-btn" onClick={haneleReset}>重置</Button>
                            <Button className="  custom-btn select-btn" onClick={handleOK}>筛选</Button>
                        </div>
                    </div>
                </div>
            </Overlay.Popup>

        </>
    );
}